import script from "./BorrowAmountLOC.vue?vue&type=script&setup=true&lang=ts"
export * from "./BorrowAmountLOC.vue?vue&type=script&setup=true&lang=ts"

import "./BorrowAmountLOC.vue?vue&type=style&index=0&id=38535d26&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38535d26"]])

export default __exports__